export default __webpack_public_path__ + "static/mob-img05-ec2ea5a36a9e0ac956f3d6e8348e7243.png";